module.exports = __webpack_public_path__ + "images/Plus_small_hover.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Plus_small_hover.png
// module id = 395
// module chunks = 0 1